import {Controller} from "@hotwired/stimulus";
import FlappyBirdGame from "../flappy_bird";

export default class extends Controller {
    connect() {
        const game = new FlappyBirdGame(this.element);
        game.init().then(() => {
            console.log("game loaded");
        });
    }
}
